/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter invoices by the beneficiary client id.
         * @param {string} [beneficiaryTitleId] Filter invoices by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to invoices for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [cascadeId] Filter invoices by the related cascade id.
         * @param {string} [invoiceNo] Case-insensitive substring match against the invoice number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerTitleId] Filter invoices by the owner title id.
         * @param {string} [ownerWorkspaceId] Restrict the search to invoices for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [payoutId] Filter invoices by the related payout id.
         * @param {string} [postedToXeroFrom] Lower bound for postedToXero. Usable alone. A YYYY-MM-DD date starts that UTC day; a datetime needs an explicit offset.
         * @param {string} [postedToXeroTo] Upper bound for postedToXero. Usable alone. A YYYY-MM-DD date covers that whole UTC day; a datetime needs an explicit offset and is inclusive.
         * @param {string} [searchTerm] Broad search term matched against invoice number, beneficiary title name, beneficiary client name and, when &#x60;beneficiaryWorkspaceId&#x60; is set, the &#x60;refNo&#x60; of finalised payouts in that workspace, using OR logic across those fields. When other filters are also provided (including dedicated &#x60;invoiceNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace an &#x60;invoiceNo&#x60; filter.
         * @param {string} [serviceId] Filter invoices by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter invoices whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {InvoiceStatusEnum} [status] Filter by invoice status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindAll: (beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/invoice`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (beneficiaryClientId !== undefined) {
                localVarQueryParameter['beneficiaryClientId'] = beneficiaryClientId;
            }
            if (beneficiaryTitleId !== undefined) {
                localVarQueryParameter['beneficiaryTitleId'] = beneficiaryTitleId;
            }
            if (beneficiaryWorkspaceId !== undefined) {
                localVarQueryParameter['beneficiaryWorkspaceId'] =
                    beneficiaryWorkspaceId;
            }
            if (cascadeId !== undefined) {
                localVarQueryParameter['cascadeId'] = cascadeId;
            }
            if (invoiceNo !== undefined) {
                localVarQueryParameter['invoiceNo'] = invoiceNo;
            }
            if (invoiceType !== undefined) {
                localVarQueryParameter['invoiceType'] = invoiceType;
            }
            if (ownerTitleId !== undefined) {
                localVarQueryParameter['ownerTitleId'] = ownerTitleId;
            }
            if (ownerWorkspaceId !== undefined) {
                localVarQueryParameter['ownerWorkspaceId'] = ownerWorkspaceId;
            }
            if (payoutId !== undefined) {
                localVarQueryParameter['payoutId'] = payoutId;
            }
            if (postedToXeroFrom !== undefined) {
                localVarQueryParameter['postedToXeroFrom'] = postedToXeroFrom;
            }
            if (postedToXeroTo !== undefined) {
                localVarQueryParameter['postedToXeroTo'] = postedToXeroTo;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (serviceId !== undefined) {
                localVarQueryParameter['serviceId'] = serviceId;
            }
            if (serviceType) {
                localVarQueryParameter['serviceType'] = serviceType;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOne: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerFindOne', 'id', id);
            const localVarPath = `/invoice/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {InvoiceFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOneDownload: (fileName, id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('invoiceControllerFindOneDownload', 'fileName', fileName);
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerFindOneDownload', 'id', id);
            const localVarPath = `/invoice/{id}/{fileName}`
                .replace(`{${'fileName'}}`, encodeURIComponent(String(fileName)))
                .replace(`{${'id'}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter invoices by the beneficiary client id.
         * @param {string} [beneficiaryTitleId] Filter invoices by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to invoices for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [cascadeId] Filter invoices by the related cascade id.
         * @param {string} [invoiceNo] Case-insensitive substring match against the invoice number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerTitleId] Filter invoices by the owner title id.
         * @param {string} [ownerWorkspaceId] Restrict the search to invoices for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [payoutId] Filter invoices by the related payout id.
         * @param {string} [postedToXeroFrom] Lower bound for postedToXero. Usable alone. A YYYY-MM-DD date starts that UTC day; a datetime needs an explicit offset.
         * @param {string} [postedToXeroTo] Upper bound for postedToXero. Usable alone. A YYYY-MM-DD date covers that whole UTC day; a datetime needs an explicit offset and is inclusive.
         * @param {string} [searchTerm] Broad search term matched against invoice number, beneficiary title name, beneficiary client name and, when &#x60;beneficiaryWorkspaceId&#x60; is set, the &#x60;refNo&#x60; of finalised payouts in that workspace, using OR logic across those fields. When other filters are also provided (including dedicated &#x60;invoiceNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace an &#x60;invoiceNo&#x60; filter.
         * @param {string} [serviceId] Filter invoices by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter invoices whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {InvoiceStatusEnum} [status] Filter by invoice status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOne(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invoiceControllerFindOne(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {InvoiceFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOneDownload(fileName, id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.invoiceControllerFindOneDownload(fileName, id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InvoicesApiFp(configuration);
    return {
        /**
         *
         * @param {string} [beneficiaryClientId] Filter invoices by the beneficiary client id.
         * @param {string} [beneficiaryTitleId] Filter invoices by the beneficiary title id.
         * @param {string} [beneficiaryWorkspaceId] Restrict the search to invoices for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [cascadeId] Filter invoices by the related cascade id.
         * @param {string} [invoiceNo] Case-insensitive substring match against the invoice number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
         * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
         * @param {string} [ownerTitleId] Filter invoices by the owner title id.
         * @param {string} [ownerWorkspaceId] Restrict the search to invoices for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {string} [payoutId] Filter invoices by the related payout id.
         * @param {string} [postedToXeroFrom] Lower bound for postedToXero. Usable alone. A YYYY-MM-DD date starts that UTC day; a datetime needs an explicit offset.
         * @param {string} [postedToXeroTo] Upper bound for postedToXero. Usable alone. A YYYY-MM-DD date covers that whole UTC day; a datetime needs an explicit offset and is inclusive.
         * @param {string} [searchTerm] Broad search term matched against invoice number, beneficiary title name, beneficiary client name and, when &#x60;beneficiaryWorkspaceId&#x60; is set, the &#x60;refNo&#x60; of finalised payouts in that workspace, using OR logic across those fields. When other filters are also provided (including dedicated &#x60;invoiceNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace an &#x60;invoiceNo&#x60; filter.
         * @param {string} [serviceId] Filter invoices by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
         * @param {Array<ServiceTypeEnum>} [serviceType] Filter invoices whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
         * @param {InvoiceStatusEnum} [status] Filter by invoice status.
         * @param {number} [page] The page number to retrieve, default &#x3D; 1
         * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
         * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options) {
            return localVarFp
                .invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOne(id, options) {
            return localVarFp
                .invoiceControllerFindOne(id, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InvoiceFileNameEnum} fileName
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFindOneDownload(fileName, id, options) {
            return localVarFp
                .invoiceControllerFindOneDownload(fileName, id, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     *
     * @param {string} [beneficiaryClientId] Filter invoices by the beneficiary client id.
     * @param {string} [beneficiaryTitleId] Filter invoices by the beneficiary title id.
     * @param {string} [beneficiaryWorkspaceId] Restrict the search to invoices for a beneficiary workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
     * @param {string} [cascadeId] Filter invoices by the related cascade id.
     * @param {string} [invoiceNo] Case-insensitive substring match against the invoice number. Independent of &#x60;searchTerm&#x60;; when both are provided, results must match this filter AND the &#x60;searchTerm&#x60; $or clause.
     * @param {InvoiceTypeEnum} [invoiceType] Filter by invoice type (send or receive).
     * @param {string} [ownerTitleId] Filter invoices by the owner title id.
     * @param {string} [ownerWorkspaceId] Restrict the search to invoices for an owner workspace. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
     * @param {string} [payoutId] Filter invoices by the related payout id.
     * @param {string} [postedToXeroFrom] Lower bound for postedToXero. Usable alone. A YYYY-MM-DD date starts that UTC day; a datetime needs an explicit offset.
     * @param {string} [postedToXeroTo] Upper bound for postedToXero. Usable alone. A YYYY-MM-DD date covers that whole UTC day; a datetime needs an explicit offset and is inclusive.
     * @param {string} [searchTerm] Broad search term matched against invoice number, beneficiary title name, beneficiary client name and, when &#x60;beneficiaryWorkspaceId&#x60; is set, the &#x60;refNo&#x60; of finalised payouts in that workspace, using OR logic across those fields. When other filters are also provided (including dedicated &#x60;invoiceNo&#x60;), this $or clause is ANDed with them — so &#x60;searchTerm&#x60; alone does not replace an &#x60;invoiceNo&#x60; filter.
     * @param {string} [serviceId] Filter invoices by the related service id. At least one of beneficiaryWorkspaceId, ownerWorkspaceId, or serviceId is required.
     * @param {Array<ServiceTypeEnum>} [serviceType] Filter invoices whose service type is in the provided list. Accepts a comma-separated string or repeated query params.
     * @param {InvoiceStatusEnum} [status] Filter by invoice status.
     * @param {number} [page] The page number to retrieve, default &#x3D; 1
     * @param {number} [pageSize] Number of items to include per page, default &#x3D; 10
     * @param {string} [sortBy] The properties and order items should be sorted, default &#x3D; \&quot;created:asc\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options) {
        return InvoicesApiFp(this.configuration)
            .invoiceControllerFindAll(beneficiaryClientId, beneficiaryTitleId, beneficiaryWorkspaceId, cascadeId, invoiceNo, invoiceType, ownerTitleId, ownerWorkspaceId, payoutId, postedToXeroFrom, postedToXeroTo, searchTerm, serviceId, serviceType, status, page, pageSize, sortBy, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    invoiceControllerFindOne(id, options) {
        return InvoicesApiFp(this.configuration)
            .invoiceControllerFindOne(id, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InvoiceFileNameEnum} fileName
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    invoiceControllerFindOneDownload(fileName, id, options) {
        return InvoicesApiFp(this.configuration)
            .invoiceControllerFindOneDownload(fileName, id, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
